import React from 'react'
import { PencilSquare } from 'react-bootstrap-icons'
import Cutoff from './cutoff'

const DropCutoff = ({
    value = '',
    onChange = () => {},
    disabled
}) => {
    return (<Cutoff icon={PencilSquare} label='Drop Cutoff' value={value} onChange={onChange} disabled={disabled} />)
}

export default DropCutoff
